export default {
  methods: {
    getOrderStatusClassAndLabel(status) {
      if (status === 0) return { class: 'text-danger', label: this.$t('miracle_deal.canceled') };
      if (status === 2) return { class: 'text-success', label: this.$t('miracle_deal.complete') };
      return { class: 'text-warning', label: this.$t('miracle_deal.waiting1') };
    }
  }
};
